import { formatDisplayDate } from "../../utils/formatDateDisplay";

export function CompanyNameRender(data: any) {
  return (
    <div>
      <p className=" font-semibold truncate"> {data.data.companyName}</p>
    </div>
  );
}
export function SuggestedMgt7FileRender(data: any) {
  const pdfImgSrc =
    "https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg";
  return (
    <div>
      {data.data.suggestedMgt7File ? (
        <div className="flex items-center space-x-2 pt-2">
          <img src={pdfImgSrc} alt="File" className="w-6 h-6 object-contain" />
          <span className="text-sm font-medium text-gray-800 truncate w-100">
            <p className=" text-sm truncate"> {data.data.suggestedMgt7File}</p>
          </span>
        </div>
      ) : (
        "-"
      )}
    </div>
  );
}
export function SuggestedPas3FileRender(data: any) {
  const pdfImgSrc =
    "https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg";
  return (
    <div>
      {data.data.suggestedPas3File ? (
        <div className="flex items-center space-x-2 pt-2">
          <img src={pdfImgSrc} alt="File" className="w-6 h-6 object-contain" />
          <span className="text-sm font-medium text-gray-800 truncate w-100">
            <p className=" text-sm truncate"> {data.data.suggestedPas3File}</p>
          </span>
        </div>
      ) : (
        "-"
      )}
    </div>
  );
}

export function CompanyIdRender(data: any) {
  return (
    <div>
      <p className="">
        {" "}
        {data.data.publishedCompanyId ? data.data.publishedCompanyId : "-"}
      </p>
    </div>
  );
}

export function PublishedDateRender(data: any) {
  return (
    <div className="whitespace-nowrap">
      <p className="">
        {data.data.publishedDate || data.data.publishedDate !== ""
          ? formatDisplayDate(data.data.publishedDate)
          : "-"}
      </p>
    </div>
  );
}

export enum CompanyState {
  PENDING = "PENDING",
  IN_PROGRESS = "IN_PROGRESS",
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
}

const statusColorMap: Record<CompanyState, string> = {
  [CompanyState.PENDING]: "bg-gray-300 text-gray-700",
  [CompanyState.IN_PROGRESS]: "bg-yellow-200 text-yellow-700",
  [CompanyState.COMPLETED]: "bg-green-200 text-green-700",
  [CompanyState.FAILED]: "bg-red-200 text-red-700",
};
export function StatusRender(data: any) {
  const status = data?.data?.status as CompanyState;
  const badgeColor = statusColorMap[status] || "bg-gray-100 text-gray-800";
  return status ? (
    <span
      className={`px-2 py-0.5 text-xs rounded-sm font-medium ${badgeColor}`}
    >
      {status}
    </span>
  ) : (
    <p className="font-medium truncate"> {"-"}</p>
  );
}

export function IsPublishedRender(data: any) {
  const status = data?.data?.isPublished;
  return status ? (
    <span
      className={`px-2 py-0.5 text-xs rounded-sm font-medium ${status === true ? "bg-blue-200 text-blue-700" : "bg-red-200 text-red-700"}`}
    >
      {status === true ? "PUBLISHED" : "NOT PUBLISHED"}
    </span>
  ) : (
    <p className="font-medium truncate"> {"-"}</p>
  );
}

const colorPalette = [
  "bg-[#241DBA]/[0.05] text-[#241DBA]/[0.7]",
  "bg-[#2DA900]/[0.05] text-[#2DA900]/[0.7]",
  "bg-[#00A3C7]/[0.05] text-[#00A3C7]",
  "bg-[#E79212]/[0.05] text-[#E79212]",
  "bg-[#F86161]/[0.05] text-[#F86161]",
  "bg-[#6904DC]/[0.2] text-[#6904DC]",
  "bg-[#BAA8ED]/[0.05] text-[#D5CBF4]",
  "bg-[#FF9F40]/[0.05] text-[#FF9F40]/[0.7]",
  "bg-[#36A2EB]/[0.05] text-[#36A2EB]/[0.7]",
  "bg-[#FF6384]/[0.05] text-[#FF6384]/[0.7]",
];

const tagsColorMap = new Map<string, string>();

export function getTagsColor(securityType: string, index: number): string {
  if (tagsColorMap.has(securityType)) {
    return tagsColorMap.get(securityType)!;
  }

  const colorIndex = index % colorPalette.length;
  const assignedColor = colorPalette[index];

  tagsColorMap.set(securityType, assignedColor);

  return assignedColor;
}

export function TagsRender(data: any) {
  return (
    <div className="flex flex-nowrap items-center gap-2 overflow-x-auto scrollbar-hidden pt-2">
      {data.data.tags?.map((tag: string, index: number) => (
        <div
          key={index}
          className={`${getTagsColor(
            tag,
            index,
          )} text-xs text-center px-3 font-semibold leading-5 rounded-md`}
        >
          {tag}
        </div>
      ))}
    </div>
  );
}
